import React, { useEffect } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { listProducts } from '../../../actions/productActions';
import Loader from '../../Loader';
import Message from '../../Message';
import Product from '../../Product';
import { FaExclamationTriangle } from 'react-icons/fa';
import { COLORS } from '../../../constants/colors';

const { warmConcrete, plum } = COLORS;

function UsersProductsScreen() {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.userReducers);
    const { products, loading, error } = useSelector((state) => state.productReducers);

    useEffect(() => {
        if (user) {
            dispatch(listProducts({ userID: user._id }));
        }
    }, [dispatch, user]);

    if (loading) {
        return <Loader />;
    }

    if (error && !error.includes('Authentication credentials were not provided')) {
        return <Message variant='danger'>{error}</Message>;
    }

    return (
        <>
            <Row className='mx-3'>
                <Col md={4} className='h5'>
                    <span className='h5' style={{ color: plum }}>My Products</span>
                </Col>
            </Row>
            <Row className='mx-3'>
                <Col className='d-flex justify-content-center mb-4'>
                    <hr className='divider'/>
                </Col>
            </Row>

            <Row className='mx-3'>
                {products && products.length > 0 ? (
                    products.map((product) => (
                        <Col key={product._id} sm={12} md={6} lg={4} xl={3}>
                            <Product product={product} />
                        </Col>
                    ))
                ) : (
                    <Col className="mt-4">
                        <Alert 
                            className="text-center p-2" 
                            style={{ 
                                backgroundColor: warmConcrete, 
                                color: plum, 
                                border: `1px solid ${plum}` 
                            }}
                        >
                            <FaExclamationTriangle size={14} style={{ marginRight: '6px' }} />
                            <strong>No products found</strong>
                        </Alert>
                    </Col>
                )}
            </Row>
        </>
    );
}

export default UsersProductsScreen; 